import { useAuth } from './useAuth';

export function useHasWorkspaceModule(moduleKey: string): boolean {
  const { enabledModules } = useAuth();
  return enabledModules.includes(moduleKey);
}
